import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { CmsDisclaimer, CmsTaxonomy, CmsTaxonomyGeneral } from '@fcom/core-api/interfaces';

@Component({
  selector: 'fin-disclaimer',
  templateUrl: 'disclaimer.component.html',
  styleUrls: ['disclaimer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DisclaimerComponent implements OnInit {
  @Input()
  disclaimer: CmsDisclaimer;

  containerClasses: string;

  ngOnInit(): void {
    const backgroundColor = this.disclaimer.backgroundColor
      ? `${this.disclaimer.backgroundColor}-bg`
      : 'nordic-blue-50-bg surface-secondary';
    const tags: CmsTaxonomy[] = this.disclaimer.subjectTaxonomyTags ?? [];
    const marginClass: string = tags.includes(CmsTaxonomyGeneral.MARGIN_SMALL)
      ? 'mr-small-b'
      : tags.includes(CmsTaxonomyGeneral.MARGIN_MEDIUM)
        ? 'mr-medium-b'
        : tags.includes(CmsTaxonomyGeneral.MARGIN_LARGE)
          ? 'mr-large-b'
          : '';
    this.containerClasses = `${backgroundColor} ${marginClass}`;
  }
}
